<template>
  <div :class="s.container">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'simple-box',
};
</script>

<style lang="scss" module="s">
.container {
  padding: 36px 50px;
  background-color: var(--primary-surface);
  border: solid 1px;
  @include sm-view {
    padding: 20px 28px;
  }
}
</style>
